import { onIssueChange } from "@mctypes/global.types";
import { IIssueApi } from "@schemas/issueSchema";
import { McInput, McTitle } from "..";
import { IssueDisabledColumnsEnum } from "../../mc-shared/enums";

const IssueTimeSection: React.FC<{
  issue: IIssueApi;
  onChange: onIssueChange;
  disabledColumns?: string[];
}> = ({ issue, onChange, disabledColumns }) => {
  return (
    <div className="d-flex flex-column">
      {disabledColumns?.includes(IssueDisabledColumnsEnum.DATESSECTION) === false && (
        <div className="even-columns mt-2">
          <div className="d-flex flex-column mr-4">
            <McTitle title="Startdato">
              <McInput
                type="date"
                onChange={(e) => onChange(issue.dates?.plannedStart, e.target.value, "dates.plannedStart")}
                value={issue.dates?.plannedStart}
              />
            </McTitle>
          </div>
          <div className="d-flex flex-column mr-4">
            <McTitle title="Tidsfrist">
              <McInput
                type="date"
                onChange={(e) => onChange(issue.dates?.due, e.target.value, "dates.due")}
                value={issue.dates?.due}
                className={
                  (issue.status === "I prosess" || issue.status === "Opprettet") &&
                  issue.dates?.due != null &&
                  new Date(issue.dates?.due) < new Date()
                    ? "border border-danger text-danger"
                    : ""
                }
              />
            </McTitle>
          </div>
          <div className="d-flex flex-column mr-4"></div>
        </div>
      )}
      <div className="even-columns mt-2">
        {disabledColumns?.includes(IssueDisabledColumnsEnum.HOURSORIGINALESTIMATE) === false && (
          <div className="d-flex flex-column mr-4">
            <McTitle title="Estimert">
              <McInput
                placeholder="Angi timer"
                pattern="^$|[0-9]+"
                onBlur={(e) =>
                  (e?.target?.value === "" && issue.hours?.orignalEstimate == null) === false &&
                  onChange(
                    issue.hours?.orignalEstimate?.toString(),
                    e?.target?.value === "" ? null : Number(e.target.value),
                    "hours.orignalEstimate",
                  )
                }
                value={issue.hours?.orignalEstimate?.toString()}
              />
            </McTitle>
          </div>
        )}
        {disabledColumns?.includes(IssueDisabledColumnsEnum.HOURSCOMPLETED) === false && (
          <div className="d-flex flex-column mr-4">
            <McTitle title="Brukt">
              <McInput
                placeholder="Angi timer"
                pattern="^$|[0-9]+"
                onBlur={(e) =>
                  (e?.target?.value === "" && issue.hours?.completed == null) === false &&
                  onChange(
                    issue.hours?.completed?.toString(),
                    e?.target?.value === "" ? null : Number(e.target.value),
                    "hours.completed",
                  )
                }
                value={issue.hours?.completed?.toString()}
              />
            </McTitle>
          </div>
        )}
        {disabledColumns?.includes(IssueDisabledColumnsEnum.HOURSREMAINING) === false && (
          <div className="d-flex flex-column mr-4">
            <McTitle title="Gjenstående">
              <McInput
                placeholder="Angi timer"
                pattern="^$|[0-9]+"
                onBlur={(e) =>
                  (e?.target?.value === "" && issue.hours?.remaining == null) === false &&
                  onChange(
                    issue.hours?.remaining?.toString(),
                    e?.target?.value === "" ? null : Number(e.target.value),
                    "hours.remaining",
                  )
                }
                value={issue.hours?.remaining?.toString()}
              />
            </McTitle>
          </div>
        )}
      </div>
    </div>
  );
};

export default IssueTimeSection;
